/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';

/**
 * 
 * @export
 * @interface AnalysisResultFaultDto
 */
export interface AnalysisResultFaultDto {
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultFaultDto
     */
    quantity: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultFaultDto
     */
    geometry?: string | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultFaultDto
     */
    fault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultFaultDto
     */
    $type?: AnalysisResultFaultDtoTypeEnum;
}


/**
 * @export
 */
export const AnalysisResultFaultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoAnalysisResultFaultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.AnalysisResultFaultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AnalysisResultFaultDtoTypeEnum = typeof AnalysisResultFaultDtoTypeEnum[keyof typeof AnalysisResultFaultDtoTypeEnum];


/**
 * Check if a given object implements the AnalysisResultFaultDto interface.
 */
export function instanceOfAnalysisResultFaultDto(value?: unknown): value is AnalysisResultFaultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AnalysisResultFaultDtoTypeEnum)[0];
}

export function AnalysisResultFaultDtoFromJSON(json: any): AnalysisResultFaultDto {
    return AnalysisResultFaultDtoFromJSONTyped(json, false);
}

export function AnalysisResultFaultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultFaultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'geometry': !exists(json, 'geometry') ? undefined : json['geometry'],
        'fault': !exists(json, 'fault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['fault']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AnalysisResultFaultDtoToJSON(value?: AnalysisResultFaultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'quantity': value.quantity,
        'geometry': value.geometry,
        'fault': AnalysisResultDtoAirPressureFaultToJSON(value.fault),
        '$type': value.$type,
    });
}

